module.exports = __webpack_public_path__ + "static/img/card4.5f98c18d.png";